import * as React from 'react';
import Helmet from 'react-helmet';
import { injectGlobal } from 'styled-components';
import styled from 'styled-components';
import Footer from '../components/Footer/Footer';
import ContentfulAsset from '../Entities/Contentful/ContentfulAsset';
import Site from '../Entities/Site';

// tslint:disable-next-line:no-unused-expression
injectGlobal`
  body {
    color: #333;
    background: #fefefe;
    font: 400 15px/1.4 'Montserrat', sans-serif;
    margin: 0;
    padding: 0;
  }

  a {
    color: #333;
    text-decoration: none;
  }
`;

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

const Push = styled.div`
  flex: 1;
`;

interface Props {
  data: {
    site: Site;
    contentfulAsset: ContentfulAsset;
  };
  location: {
    pathname: string;
  };
  children: any;
}

interface State {
  footerInView: boolean;
}

export default class extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      footerInView: false
    };
  }
  public render() {
    return (
      <Wrapper>
        <Helmet title={this.props.data.site.siteMetadata.title} />
        <Push>{this.props.children()}</Push>
        {this.props.data.contentfulAsset && (
          <Footer
            image={this.props.data.contentfulAsset.file ? { src: this.props.data.contentfulAsset.file.url } : undefined}
          />
        )}
      </Wrapper>
    );
  }
}

export const IndexLayoutQuery = graphql`
  query IndexLayoutQuery {
    site {
      siteMetadata {
        title
      }
    }
    contentfulAsset(title: { eq: "Elesthorp logo gray" }) {
      file {
        fileName
        url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.tsx